import leftButtonGroupStyle from "../devices-left-button-group.module.css";

import { ButtonGroup } from "react-bootstrap";

// Package
import { useTranslation } from "react-i18next";

// UI components
import Button from "components/Button";

const LeftButtonGroup = ({
  modalStatus,
  changeModalStatus,
  addBtnDisable,
  deleteBtnDisable,
  assignToBtnDisable,
  assignLicenseBtnDisable,
}) => {
  const { t } = useTranslation();
  return (
    <div
      className={`d-flex justify-content-between ${leftButtonGroupStyle["left-button-group-contianer"]}`}
    >
      <ButtonGroup>
        <Button
          label={t("5290e89436")}
          disabled={addBtnDisable}
          onClick={() => changeModalStatus("addDevice", true)}
        ></Button>
        <Button
          label={t("f2a6c498fb")}
          disabled={deleteBtnDisable}
          onClick={() => changeModalStatus("deleteDevice", true)}
        ></Button>
        <Button
          label={t("412a9172e0")}
          disabled={assignToBtnDisable}
          onClick={() => changeModalStatus("assignTo", true)}
        ></Button>
        <Button
          label={t("cb6d8302ba")}
          disabled={assignLicenseBtnDisable}
          onClick={() => changeModalStatus("assignLicense", true)}
        ></Button>
      </ButtonGroup>
    </div>
  );
};

export default LeftButtonGroup;
